import * as e from 'react';
import { forwardRef, memo } from 'react';

var f=({title:r,titleId:t,...o},s)=>e.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",fill:"currentColor",viewBox:"0 0 16 16",ref:s,"aria-labelledby":t,...o},r?e.createElement("title",{id:t},r):null,e.createElement("path",{d:"M6 2v12H4V2zm6 0v12h-2V2z"})),i=forwardRef(f),m=memo(i),S=m;

export { S as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-SPR2T5CD.mjs.map